import { PermissionsLables } from "../enums/Permissions.enum";

export class MenuConfig {
  public defaults: any = {
    header: {
      self: {},
      items: [],
    },
    aside: {
      self: {},
      items: [
        {
          title: "Dashboard",
          icon: "fa fa-tachometer-alt",
          page: "dashboard",
        },
        // E -Commerce MANAGEMENT
        {
          section: "Catalog",
          permissions: [
            PermissionsLables.ReadProducts,
            PermissionsLables.ReadShippingPreferences,
            PermissionsLables.ReadCategories,
            PermissionsLables.ReadVariants,
            PermissionsLables.ReadBrands,
            PermissionsLables.ReadPaymentTypes,
            PermissionsLables.ReadBundle,
          ],
        },
        {
          title: "Products",
          icon: "fa fa-shopping-cart",
          bullet: "dot",
          page: "commerce/products",
          permissions: [PermissionsLables.ReadProducts], //, 'Read Approve Product'],
          // submenu: [
          //   {
          //     title: "Products",
          //     page: "commerce/products",
          //     // permissions: ['Read Product'],
          //   },
          // ],
        },
        {
          title: "Categories",
          icon: "fa fa-shapes",
          page: "commerce/categories",
          permissions: [PermissionsLables.ReadCategories],
        },
        // {
        //   title: "Variants",
        //   icon: "fa fa-arrows-alt",
        //   page: "commerce/variants",
        //   // permissions: ['Read Varient'],
        // },
        {
          title: "Brands",
          icon: "fa fa-bookmark",
          page: "commerce/brands",
          permissions: [PermissionsLables.ReadBrands],
        },
        {
          title: "PaymentType",
          icon: "fa fa-credit-card",
          page: "commerce/payment-type",
          permissions: [PermissionsLables.ReadPaymentTypes],
        },
        {
          title: "Tenant",
          icon: "fa fa-credit-card",
          page: "commerce/tenant",
        },
        // {
        //   title: "Bundles",
        //   icon: "fa fa-gifts",
        //   page: "commerce/bundles",
        //   permissions: ['Read Bundle'],
        // },
        // {
        //   title: "Something wrong",
        //   icon: "fa fa-sad-tear",
        //   page: "commerce/Something-wrong",
        //   // permissions: ['Read SomethingWrong'],
        // },
        {
          title: "Shipping Preference",
          icon: "fa fa-shipping-fast",
          page: "commerce/shipping-preference",
          permissions: [PermissionsLables.ReadShippingPreferences],
        },
        // Notifications
        {
          section: "Notifications",
        },
        {
          title: "Notifications History",
          icon: "fa fa-sort-amount-up-alt",
          page: "notifications/notifications-list",
          permissions: [PermissionsLables.ReadNotifications],
        },
        {
          section: "Sales",
          permissions: [
            PermissionsLables.ReadTaxes,
            PermissionsLables.ReadOrders,
            PermissionsLables.ReadPointCodes,
          ],
        },
        // {
        //   title: "Orders",
        //   icon: "fa fa-truck-loading",
        //   page: "orders/orders-list",
        //   // permissions: ['Read Order'],
        // },
        // {
        //   section: "Sales",
        //   // permissions: ['Read Order', 'Read Order Status', 'Read Tax']
        // },
        {
          title: "Orders",
          icon: "fa fa-truck-loading",
          page: "orders/orders-list",
          permissions: [PermissionsLables.ReadOrders],
        },
        {
          title: "User To User Delivery",
          icon: "fa fa-truck",
          page: "orders/user-to-user-delivery",
          permissions: [PermissionsLables.ReadOrders],
        },
        {
          title: "Buy On Behalf Order",
          icon: "fa fa-shopping-bag",
          page: "orders/buy-on-behalf-order",
          permissions: [PermissionsLables.ReadOrders],
        },
        // {
        //   title: "Orders Status",
        //   icon: "fa fa-cart-plus",
        //   page: "orders/status",
        //   // permissions: ['Read Order Status'],
        // },
        {
          title: "Tax",
          icon: "fa fa-money-check-alt",
          page: "orders/tax-groups",
          permissions: [PermissionsLables.ReadTaxes],
        },
        {
          title: "Discount Over Limit",
          icon: "fa fa-money-check-alt",
          page: "orders/Discount-Over-Limit",
          permissions: [PermissionsLables.ReadDiscounts],
        },
        {
          title: "Discount On Delivery Over Limit",
          icon: "fa fa-money-check-alt",
          page: "orders/Discount-On-Delivery-Over-Limit",
          permissions: [PermissionsLables.ReadDiscounts],
        },
        {
          title: "Discount On Payment Type",
          icon: "fa fa-money-check-alt",
          page: "orders/Discount-On-PaymentType",
          permissions: [PermissionsLables.ReadDiscounts],
        },
        {
          title: "Delivery On Store",
          icon: "fa fa-money-check-alt",
          page: "orders/Delivery-On-Store",
          permissions: [PermissionsLables.ReadDiscounts],
        },

        // {
        //   title: "Loyalty",
        //   icon: "fa fa-hand-holding-heart",
        //   bullet: "dot",
        //   // permissions: ['Read Loyalty','Write Loyalty'],
        //   submenu: [
        //     // {
        //     //   title: "Loyalty",
        //     //   page: "orders/loyalty-list",
        //     //   permissions: ['Read Loyalty'],
        //     // },
        {
          icon: "fa fa-map-marker",
          title: "Point Code",
          page: "settings/loyalty/pointCode",
          permissions: [PermissionsLables.ReadPointCodes],
        },
        //   ],
        // },

        // Marketing
        {
          section: "Marketing",
          permissions: [PermissionsLables.ReadCoupons],
        },
        // {
        //   title: "Advertisements",
        //   icon: "fa fa-ad",
        //   page: "layout/adv",
        //   // permissions: ['Read Advertisement'],
        // },
        {
          title: "Coupons",
          icon: "fa fa-gift",
          page: "orders/coupons",
          permissions: [PermissionsLables.ReadCoupons],
        },
        {
          title: "Gift Card",
          icon: "fa fa-gift",
          page: "orders/gift-card",
          permissions: [PermissionsLables.ReadGiftCard],
        },
        // {
        //   title: "Prices",
        //   icon: "fa fa-money-bill-alt",
        //   page: "commerce/products/price-management",
        //   // permissions: ['Read Price Mang'],
        // },
        // USERS MANAGEMENT
        {
          section: "USERS",
          // permissions: ['Read Admin',
          // 'Read Vendor',
          // 'Read Vendor Application',
          // 'Read Customer'
          // ]
        },
        {
          title: "Stores",
          icon: "fa fa-user-check",
          page: "Stores",
          permissions: [
            PermissionsLables.ReadStores,
            PermissionsLables.ReadStoreSigningRequests,
            PermissionsLables.ReadStoreSigningRequests,
          ],
          submenu: [
            {
              title: "Stores",
              // icon: "fa fa-user-check",
              page: "users/stores",
              permissions: [PermissionsLables.ReadStores],
            },
            {
              title: "Stores Commmissions",
              // icon: "fa fa-user-check",
              page: "users/store-commission",
              permissions: [PermissionsLables.ReadStoreCommissions],
            },
            {
              title: "Stores Signing Requests",
              //  icon: "fa fa-user-check",
              page: "users/stores-signing-request",
              permissions: [PermissionsLables.ReadStoreSigningRequests],
            },
          ],
        },
        // {
        //   title: "System Admins",
        //   icon: "fa fa-user-cog",
        //   page: "users/systemAdmins",
        //   // permissions: ['Read Admin'],
        // },
        // {
        //   title: "Vendors",
        //   icon: "fa fa-user-check",
        //   bullet: "dot",
        //   // permissions: ['Read Vendor', 'Read Vendor Application'],
        //   submenu: [
        //     {
        //       title: "Vendors",
        //       page: "users/vendors",
        //       // permissions: ['Read Vendor'],
        //     },
        //     {
        //       title: "Vendors Applications",
        //       page: "users/VendorsApplications",
        //       // permissions: ['Read Vendor Application'],
        //     }
        //   ],
        // },
        {
          title: "Customers",
          icon: "fa fa-users",
          permissions: [PermissionsLables.ReadUsers],
          submenu: [
            {
              title: "Clients",
              page: "users/customers",
              permissions: [PermissionsLables.ReadUsers],
            },
            // {
            //   title: "Vendor",
            //   page: "users/vendors",
            //   permissions: [PermissionsLables.ReadUsers],
            // },
            {
              title: "DeliveryAgent",
              page: "users/delivery-agents",
              permissions: [PermissionsLables.ReadUsers],
            },
          ],
        },
        {
          title: "System Admins",
          icon: "fa fa-users",
          page: "users/admins",
          permissions: [PermissionsLables.ReadUsers],
        },
        // // PRIVILEGES MANAGEMENT
        // {
        //   section: "PRIVILEGES",
        //   // permissions: ['Read Role']
        // },
        {
          title: "Roles",
          icon: "fa fa-tags",
          page: "privileges/roles",
          permissions: [PermissionsLables.ReadPermissions],
        },
        // {
        //   title: "Permissions Categories",
        //   icon: "fa fa-list",
        //   page: "privileges/categories",
        //   // permissions: ['Read Role'],
        // },
        // {
        //   title: "Interfaces",
        //   icon: "fa fa-desktop",
        //   page: "privileges/interfaces",
        // },
        // Settings
        {
          section: "SETTINGS",
          permissions: [
            PermissionsLables.ReadCountries,
            PermissionsLables.ReadBanner,
            PermissionsLables.ReadVariants,
            PermissionsLables.ReadLanguage,
          ],
        },
        {
          title: "Countries",
          icon: "fa fa-flag",
          page: "settings/countries",
          permissions: [PermissionsLables.ReadCountries],
        },
        {
          title: "Banners",
          icon: "fa fa-desktop",
          page: "settings/banners",
          permissions: [PermissionsLables.ReadBanner],
        },
        {
          title: "Variants",
          icon: "fa fa-arrows-alt",
          page: "settings/variantkey",
          permissions: [PermissionsLables.ReadVariants],
        },
        {
          title: "Languages",
          icon: "fa fa-language",
          page: "settings/Languages",
          permissions: [PermissionsLables.ReadLanguage],
        },
        {
          title: "Delivery Fee Configuration",
          icon: "fa fa-dollar-sign",
          page: "settings/delivery-fee-configuration",
          permissions: [PermissionsLables.ManageUsers],
        },
        // {
        //   title: "Channels",
        //   icon: "fa fa-list-ul",
        //   page: "settings/channels",
        //   // permissions: ['Read Channel'],
        // },
        // Layout
        // {
        //   section: "Layout",
        //   // permissions: ['Read Screen Mang']
        // },
        // {
        //   title: "Screens Sections",
        //   icon: "fa fa-th-list",
        //   page: "layout/sections",
        //   // permissions: ['Read Screen Mang'],
        // },
        //  {
        //   section: "Reporting",
        //   permissions: [PermissionsLables.ReadReports]
        // },
        // {
        //   title: "Reports",
        //   icon: "fa fa-wave-square",
        //   page: "reports",
        //    permissions: [PermissionsLables.ReadReports],
        //    submenu: [
        //     {
        //       title: "LineChart",
        //       page: "reports/LineChart",

        //       // permissions: ['Read Product'],
        //     },
        //     {
        //       title: "PieChart",
        //       page: "reports/PieChart",

        //       // permissions: ['Read Product'],
        //     },
        //     {
        //       title: "BarChart",
        //       page: "reports/BarChart",

        //       // permissions: ['Read Product'],
        //     },]

        // },
      ],
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
